export default __webpack_public_path__ + "locales/es/WebPlugins.json?hash=b6ba4a934421f55c20e968d902dd023e";